export enum UploadState {
  New = 'NEW',
  Loading = 'LOADING',
  Canceled = 'CANCELED',
  Loaded = 'LOADED',
  Pending = 'PENDING',
  Done = 'DONE',
}
